import { pathgen } from 'object-path-generator';
import { useRef } from 'react';
import { useOverlayContext } from 'seagull';
export const allowedExtensions = ['jpg', 'jpeg', 'png', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv'];
export const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20MB in bytes
export const DEFAULT_MAX_TOTAL_SIZE = 25 * 1024 * 1024; // 25MB in bytes

export const AttachFilesTestIds = pathgen('AttachFilesTestIds');
export const useAttachFiles = _ref => {
  let {
    onSubmit,
    maxTotalSize = DEFAULT_MAX_TOTAL_SIZE,
    maxFileSize = MAX_FILE_SIZE
  } = _ref;
  const fileInputRef = useRef(null);
  const {
    showErrorToast
  } = useOverlayContext();
  const handleButtonClick = () => {
    var _fileInputRef$current;
    (_fileInputRef$current = fileInputRef.current) === null || _fileInputRef$current === void 0 || _fileInputRef$current.click();
  };
  const resetFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };
  const handleFileChange = e => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const allFiles = Array.from(files);
      const validFiles = allFiles.filter(file => {
        var _file$name$split$pop;
        const extension = (_file$name$split$pop = file.name.split('.').pop()) === null || _file$name$split$pop === void 0 ? void 0 : _file$name$split$pop.toLowerCase();
        return extension && allowedExtensions.includes(extension);
      });
      const hasUnsupportedFiles = validFiles.length !== allFiles.length;
      if (hasUnsupportedFiles) {
        showErrorToast('Unsupported file type', AttachFilesTestIds.UnsupportedFileTypeErrorToast());
        resetFileInput();
        return;
      }
      const totalSize = validFiles.reduce((sum, file) => sum + file.size, 0);
      const exceedsTotalSizeLimit = totalSize > maxTotalSize;
      if (exceedsTotalSizeLimit) {
        showErrorToast("Attachments exceeded the ".concat(maxTotalSize / (1024 * 1024), "MB upload limit"), AttachFilesTestIds.TotalSizeExceededErrorToast());
        resetFileInput();
        return;
      }
      const filesWithinSizeLimit = validFiles.filter(file => file.size <= maxFileSize);
      const hasFilesExceedingIndividualLimit = filesWithinSizeLimit.length !== validFiles.length;
      if (hasFilesExceedingIndividualLimit) {
        showErrorToast("File exceeds the ".concat(maxFileSize / (1024 * 1024), "MB size limit"), AttachFilesTestIds.FileSizeExceededErrorToast());
        resetFileInput();
        return;
      }
      onSubmit(filesWithinSizeLimit);
    }
    resetFileInput();
  };
  return {
    fileInputRef,
    handleButtonClick,
    handleFileChange,
    allowedExtensions
  };
};